/* eslint-disable @typescript-eslint/naming-convention */
import { Button, Grid, Typography } from '@mui/material';
import userLoginLogo from 'assets/Images/Auth/authotp.png';
import EnterOtpInput from 'components/Common/EnterOtpInput';
import OtpTimer from 'components/OtpTimer';
import Enums from 'constants/Enums';
import { getLocalStorageItem, setLocalStorageItem } from 'hooks';
import {
  useForgetPasswordSentCodeQuery,
  useResendCodeQuery,
} from 'queries/AuthQueries';
import type { FC } from 'react';
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

const ForgotPinPopup: FC<{
  setOpen: any;
  handleNewPinScreen: (args?: any) => void;
  modalDetails?: any;
}> = ({ setOpen, handleNewPinScreen, modalDetails }) => {
  const { t } = useTranslation('account');
  const [otp, setOtp] = useState<any>(0);
  const [otpCheck, setOtpcheck] = useState<boolean>(false);
  const [over, setOver] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string>('');
  const [additionalField, setAdditionalField] = useState<string>('');
  const { mutate: resendCodeApi, isLoading } = useResendCodeQuery();
  const { mutate: forgotPasswordOtpCode } = useForgetPasswordSentCodeQuery();

  const {
    handleSubmit,
    setError,
    formState: { errors },
  } = useForm({});
  // handlers

  const handleOver = () => {
    setOtpcheck(true);
  };
  const submitAuthForm = () => {
    const { username } = getLocalStorageItem('roles');
    const payloadOtp: any = {
      code: otp,
      sendOn: username,
      eventCode: Enums.EventType.PIN_RESET,
    };
    setLocalStorageItem('forgotCreds', payloadOtp);
    forgotPasswordOtpCode(payloadOtp, {
      onSuccess: () => {
        // setOpen(false);
        handleNewPinScreen(true);
      },
      onError: (err: any) => {
        setErrorMessage(err?.fieldErrors[0]?.message);
      },
    });
  };

  useEffect(() => {
    if (otp?.length === 6) {
      submitAuthForm();
    }
  }, [otp]);
  const handleAuthErrors = (err: any) => {
    console.log(err, 'errors');
  };

  useEffect(() => {
    if (modalDetails[2]) {
      setAdditionalField(`,${modalDetails[2]}`);
    }
  }, [modalDetails]);

  return (
    <div className="mx-auto  rounded-[12px]">
      <div className="mx-auto mb-4 text-center">
        <img src={userLoginLogo} alt="" className="mb-3" />
        <Typography
          fontWeight={600}
          variant="h5"
          color="secondary.100"
          align="center"
        >
          {t('forgotPin')}
        </Typography>

        <Typography
          fontWeight={400}
          variant="subtitle1"
          color="font.900"
          align="center"
          marginTop={2}
        >
          {modalDetails[0]} {modalDetails[1]} {additionalField || ''}
          <br />
        </Typography>
      </div>
      <form
        id="login-form"
        onSubmit={handleSubmit(submitAuthForm, handleAuthErrors)}
        className="pt-2"
      >
        <Grid item container spacing={2} xs={12}>
          <Grid item xs={12}>
            <EnterOtpInput
              otpDigit={6}
              value={otp}
              onChange={(userOTP: string) => {
                setOtp(userOTP);
              }}
            />
          </Grid>
          {errorMessage && (
            <div className="flex w-full items-center justify-center">
              <p className="text-md font-normal text-error-500">
                {errorMessage}
              </p>
            </div>
          )}
          <Grid item xs={12} className="mt-3">
            <Button
              id="login-form"
              fullWidth
              type="submit"
              disabled={otp?.length < 6}
              className="bg-[#11AC9E] hover:bg-[#90BEE6]"
            >
              {t('confirm')}{' '}
            </Button>
            {!otpCheck ? (
              <div className="!w-[100%] pt-3 text-right">
                <OtpTimer
                  minutes={1}
                  seconds={0}
                  over={over}
                  handleOver={handleOver}
                />
              </div>
            ) : (
              ''
            )}
            {otpCheck ? (
              <Typography
                fontWeight={600}
                variant="subtitle1"
                color="primary.600"
                align="center"
                paddingTop={2}
                className="hover:cursor-pointer"
                onClick={() => {
                  const { username } = getLocalStorageItem('roles');
                  const payload: any = {
                    sendOn: username,
                    eventCode: Enums.EventType.PIN_RESET,
                  };
                  resendCodeApi(payload, {
                    onSuccess: () => {
                      setOtpcheck(false);
                    },
                  });
                  setOtpcheck(false);
                }}
              >
                {t('resendCode')}
              </Typography>
            ) : (
              ''
            )}
          </Grid>
        </Grid>
      </form>
    </div>
  );
};

export default ForgotPinPopup;
